import { useState } from 'react';

import { FundData, FundDistribution } from './ExpandableTable';

interface PropShape {
    data: FundData;
    id: number;
}

const ExpandableRow = ({ data, id }: PropShape) => {
    const [showSection, setShowSection] = useState<boolean>(false);

    return (
        <>
            <tr key={id} className="expandable-row">
                <td onClick={() => setShowSection(!showSection)}>
                    <span>
                        <i
                            className={`icon 
                    ${showSection ? `fa fa-angle-down` : `fa fa-angle-right`}`}
                        />
                    </span>
                    <span>{data.fundName}</span>
                </td>
                <td>{data.fundAllocation}</td>
            </tr>
            {showSection &&
                data.fundDistribution.map((f: FundDistribution, _index: number) => (
                    <tr className="expanded-content " key={_index}>
                        <td>{f.companyName}</td>
                        <td>{f.percentage}</td>
                    </tr>
                ))}
        </>
    );
};

export default ExpandableRow;
